"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-93cfce24"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "oplus-table-wrapper" };
const _hoisted_2 = { class: "oplus-table" };
const _hoisted_3 = {
    key: 0,
    rowspan: "2"
};
const _hoisted_4 = {
    key: 1,
    rowspan: "2"
};
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { rowspan: "2" }, "業務名", -1 /* HOISTED */));
const _hoisted_6 = {
    key: 2,
    rowspan: "2"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { rowspan: "2" }, "シフト", -1 /* HOISTED */));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { rowspan: "2" }, "休憩時間", -1 /* HOISTED */));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { rowspan: "2" }, "説明", -1 /* HOISTED */));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { rowspan: "2" }, "時給", -1 /* HOISTED */));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { rowspan: "2" }, "割り当て方法", -1 /* HOISTED */));
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { rowspan: "2" }, "種類", -1 /* HOISTED */));
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { rowspan: "2" }, "次の日休み", -1 /* HOISTED */));
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("th", {
    class: "shift-type-header",
    colspan: "2"
}, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "シフト表に表示")
], -1 /* HOISTED */));
const _hoisted_15 = {
    key: 3,
    class: "delete-btn-cell",
    rowspan: "2"
};
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("tr", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { class: "role-count-cell" }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "カウント")
    ]),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "割当")
    ])
], -1 /* HOISTED */));
const _hoisted_17 = { key: 0 };
const _hoisted_18 = { key: 1 };
const _hoisted_19 = { class: "roles-name-cell d-flex" };
const _hoisted_20 = { key: 2 };
const _hoisted_21 = { key: 3 };
const slotTypesToString_1 = require("../common/slotTypesToString");
const models_1 = require("../js/models");
const GroupRoleIconLg_vue_1 = __importDefault(require("./icons/GroupRoleIconLg.vue"));
const rolesStaffTableTypes_1 = require("./rolesStaffView/rolesStaffTableTypes");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RolesTable',
    props: {
        roles: {},
        isGroupRoleForm: { type: Boolean },
        useForCreateOrEdit: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        function roleColor(role) {
            const s = {
                backgroundColor: `#${role.color}`,
                color: '',
            };
            if (role.color && role.color !== models_1.OPLUS_COLOR_PALETTE.DEFAULT && role.color !== "none") {
                s.color = "#fff";
            }
            return s;
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("table", _hoisted_2, [
                    (0, vue_2.createElementVNode)("thead", null, [
                        (0, vue_2.createElementVNode)("tr", null, [
                            (!_ctx.isGroupRoleForm && !_ctx.useForCreateOrEdit)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", _hoisted_3, "並替"))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (!_ctx.useForCreateOrEdit)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", _hoisted_4, "編集"))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            _hoisted_5,
                            (!_ctx.useForCreateOrEdit && _ctx.isGroupRoleForm)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", _hoisted_6, "使用中の拠点数"))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            _hoisted_7,
                            _hoisted_8,
                            _hoisted_9,
                            _hoisted_10,
                            _hoisted_11,
                            _hoisted_12,
                            _hoisted_13,
                            _hoisted_14,
                            (!_ctx.useForCreateOrEdit)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", _hoisted_15))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ]),
                        _hoisted_16
                    ]),
                    (0, vue_2.createElementVNode)("tbody", null, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(_ctx.roles, (role) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                                key: role.id
                            }, [
                                (!_ctx.useForCreateOrEdit)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_17, [
                                        (0, vue_2.createCommentVNode)(" Sort Icon ")
                                    ]))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (!_ctx.useForCreateOrEdit)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_18, [
                                        (0, vue_2.createCommentVNode)(" Edit Icon ")
                                    ]))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("td", null, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_19, [
                                        (role.isGroupWide)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(GroupRoleIconLg_vue_1.default, { key: 0 }))
                                            : (0, vue_2.createCommentVNode)("v-if", true),
                                        (0, vue_2.createElementVNode)("span", {
                                            class: "role-name",
                                            style: (0, vue_2.normalizeStyle)(roleColor(role))
                                        }, (0, vue_2.toDisplayString)(role.name || "業務名"), 5 /* TEXT, STYLE */)
                                    ])
                                ]),
                                (!_ctx.useForCreateOrEdit && _ctx.isGroupRoleForm)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_20, [
                                        (0, vue_2.createCommentVNode)(" Active branch count ")
                                    ]))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)(role.from) + " ~ " + (0, vue_2.toDisplayString)(role.to), 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)(role.rest || "0:00"), 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)(role.purpose || "無"), 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)(role.wage || 0), 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_TEXT)[role?.type || 0]), 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(slotTypesToString_1.slotTypeString)[role?.slotType || 0]), 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("td", null, [
                                    (0, vue_2.createElementVNode)("i", {
                                        class: (0, vue_2.normalizeClass)(["zmdi zmdi-hc-lg", role.nextDayOff ? 'zmdi-check role-check-color' : 'zmdi-close'])
                                    }, null, 2 /* CLASS */)
                                ]),
                                (0, vue_2.createElementVNode)("td", null, [
                                    (0, vue_2.createElementVNode)("i", {
                                        class: (0, vue_2.normalizeClass)(["zmdi zmdi-hc-lg", role.showCount ? 'zmdi-check role-check-color' : 'zmdi-close'])
                                    }, null, 2 /* CLASS */)
                                ]),
                                (0, vue_2.createElementVNode)("td", null, [
                                    (0, vue_2.createElementVNode)("i", {
                                        class: (0, vue_2.normalizeClass)(["zmdi zmdi-hc-lg", role.showStaffCount ? 'zmdi-check role-check-color' : 'zmdi-close'])
                                    }, null, 2 /* CLASS */)
                                ]),
                                (!_ctx.useForCreateOrEdit)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_21, [
                                        (0, vue_2.createCommentVNode)(" Delete button ")
                                    ]))
                                    : (0, vue_2.createCommentVNode)("v-if", true)
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ])
            ]));
        };
    }
});
